@let current = currentField();
@let isBlocked = blocked();
@let isDefault = type() === cardTypes.DEFAULT;
@let data = value();

<card-base
    [field]="field()"
    [favoriteField]="favoriteField()"
    [trashField]="trashField()"
    [type]="type()"
    [disabled]="isBlocked"
    [selected]="selected()"
    [showAi]="false"
    [textZone]="false"
    [block]="true">

    <!-- Rail: palavras da escala. -->
    <div
        card-toolbar
        class="sem-rail">
        @if (isDefault) {
            <div class="rail-chip-wrapper">
                <button
                    type="button"
                    class="rail-chip"
                    [class.open]="look.isOpen()"
                    [class.default-disabled]="isBlocked"
                    [attr.aria-label]="'document.edit.semaphoreCard.scale' | translate"
                    [raEditTooltip]="look.isOpen() ? null : { text: ('document.edit.semaphoreCard.scale' | translate), position: 'left' }"
                    [raLookPanel]="lookTpl"
                    lookPanelTitle="document.edit.semaphoreCard.scale"
                    lookPanelIcon="setting"
                    [lookPanelItemId]="field()?._id"
                    [lookPanelDisabled]="isBlocked"
                    #look="lookPanel"
                    (click)="look.toggle()">
                    <span class="scale-glyph" aria-hidden="true"><i></i><i></i><i></i></span>
                </button>

                <ng-template #lookTpl>
                    <div class="look-panel-body" (focusin)="onFocusIn()" (focusout)="onFocusOut($event)">
                        <p class="rail-menu-title">{{ 'document.edit.semaphoreCard.scale' | translate }}</p>
                        @for (key of keys; track key) {
                            <label class="scale-row">
                                <i [class]="'scale-dot ' + key"></i>
                                <input
                                    type="text"
                                    autocomplete="off"
                                    [value]="scaleLabelRaw(key)"
                                    [placeholder]="labelOf(key)"
                                    [attr.maxlength]="limits.MAX_SCALE_LABEL_LENGTH"
                                    [disabled]="isBlocked"
                                    (input)="onScaleInput(key, $event)"
                                    (change)="commit()"
                                    (keydown)="blurOnEnter($event)"
                                />
                            </label>
                        }
                    </div>
                </ng-template>
            </div>
        }
    </div>

    @if (isDefault) {
        <!-- A lista como imprime, editável no lugar. -->
        <div
            class="sem-editor"
            [style.font-family]="editDataService.documentFontFamily()"
            (focusin)="onFocusIn()"
            (focusout)="onFocusOut($event)"
            (click)="$event.stopPropagation()">

            <div class="sem-summary">
                <div class="sem-bar">
                    @for (key of keys; track key) {
                        <i [class]="key" [style.flex]="stats().counts[key]"></i>
                    }
                    @if (stats().unrated > 0) {
                        <i class="none" [style.flex]="stats().unrated"></i>
                    }
                </div>
                <div class="sem-counts">
                    @for (key of keys; track key) {
                        <span [class]="key"><b>{{ stats().counts[key] }}</b> {{ labelOf(key) }}</span>
                    }
                </div>
            </div>

            <div
                class="sem-list"
                cdkDropList
                [cdkDropListData]="data.items"
                [cdkDropListDisabled]="isBlocked"
                (cdkDropListDropped)="drop($event)">
                @for (item of data.items; track $index; let i = $index) {
                    <div class="sem-item" cdkDrag cdkDragLockAxis="y">
                        <span class="item-tools">
                            <span
                                class="item-action item-grip"
                                cdkDragHandle
                                [attr.aria-label]="'document.edit.semaphoreCard.dragItem' | translate"
                                [raEditTooltip]="{ text: ('document.edit.semaphoreCard.dragItem' | translate), position: 'left' }">
                                <ra-icon icon="menu" varColor="currentColor" [size]="12" />
                            </span>
                            <button
                                type="button"
                                tabindex="-1"
                                class="item-action item-remove"
                                [disabled]="isBlocked"
                                [attr.aria-label]="'document.edit.semaphoreCard.removeItem' | translate"
                                [raEditTooltip]="{ text: ('document.edit.semaphoreCard.removeItem' | translate), position: 'left' }"
                                (click)="removeItem(i)">
                                <ra-icon icon="trash" varColor="currentColor" [size]="12" />
                            </button>
                        </span>

                        <div
                            class="sem-label"
                            [attr.data-label]="i"
                            [attr.data-placeholder]="'document.edit.semaphoreCard.itemPlaceholder' | translate"
                            [attr.contenteditable]="isBlocked ? 'false' : 'plaintext-only'"
                            [tableCellText]="item.label"
                            (cellTextChange)="onLabelInput(i, $event)"
                            (keydown)="blurOnEnter($event)"></div>

                        <span class="sem-scale">
                            @for (key of keys; track key) {
                                <button
                                    type="button"
                                    [class]="'sem-opt ' + key + (item.status === key ? ' sel' : '')"
                                    [disabled]="isBlocked"
                                    [attr.aria-pressed]="item.status === key"
                                    (click)="setStatus(i, key)">
                                    <i></i>{{ labelOf(key) }}
                                </button>
                            }
                        </span>

                        <!-- Descrição: quem tem mostra o texto; nas outras linhas fica sempre à
                             vista um "Adicionar descrição" com cara de placeholder, no mesmo
                             lugar e tamanho do campo, que abre ao clicar. Vazio ao sair, volta. -->
                        @if (item.description !== undefined) {
                            <div
                                class="sem-desc"
                                [attr.data-desc]="i"
                                [attr.data-placeholder]="'document.edit.semaphoreCard.descriptionPlaceholder' | translate"
                                [attr.contenteditable]="isBlocked ? 'false' : 'plaintext-only'"
                                [tableCellText]="item.description"
                                (cellTextChange)="onDescriptionInput(i, $event)"
                                (keydown)="blurOnEnter($event)"
                                (blur)="onDescriptionBlur(i)"></div>
                        } @else if (!isBlocked) {
                            <button type="button" tabindex="-1" class="desc-add" (click)="openDescription(i)">
                                {{ 'document.edit.semaphoreCard.descriptionPlaceholder' | translate }}
                            </button>
                        }
                    </div>
                }
            </div>

            @if (canAdd()) {
                <button type="button" class="sem-add" [disabled]="isBlocked" (click)="addItem()">
                    <ra-icon icon="add" varColor="currentColor" [size]="14" />
                    <span>{{ 'document.edit.semaphoreCard.addItem' | translate }}</span>
                </button>
            }
        </div>
    } @else {
        <semaphore-view [value]="current.value" [maxItems]="5" />
    }
</card-base>
